<template>
    <simple-layout
        :models-loaded="true"
        :name="getVerbose('permissions_simple_layout_breadcrumb')"
        class="permission-management"
    >
        <el-card style="margin-top: 15px;">

            <el-tabs v-model="currentTab">
                <el-tab-pane
                    :label="getVerbose('permissions_table_column_label_roles')"
                    name="manage-roles"
                >
                    <role-and-users>
                    </role-and-users>
                </el-tab-pane>
                <el-tab-pane
                    :label="getVerbose('permissions_table_column_label_models')"
                    name="manager-models-permissions"
                >
                    <el-alert
                        v-if="concreteRoles.length === 0"
                        :title="getVerbose('permissions_alert_no_roles_title')"
                        :description="getVerbose('permissions_alert_no_roles_desc')"
                        type="info"
                        show-icon
                    >
                    </el-alert>
                    <h1>{{ getVerbose('permissions_title') }}</h1>
                    <div class="permission-header">
                        <strong class="model-name">{{ getVerbose('permissions_roles_main_column_label') }}</strong>
                        <div class="roles-titles">
                            <strong>{{ getVerbose('permissions_roles_create_column_label') }}</strong>
                            <strong>{{ getVerbose('permissions_roles_delete_column_label') }}</strong>
                            <strong>{{ getVerbose('permissions_roles_update_column_label') }}</strong>
                            <strong>{{ getVerbose('permissions_roles_retrieve_column_label') }}</strong>

                        </div>
                    </div>
                    <el-divider></el-divider>
                    <model-permission
                        v-for="perm in concretePermissions"
                        ref="perm"
                        :key="perm.uid"
                        :permission="perm"
                    ></model-permission>
                    <el-button
                        type="primary"
                        class="btn-save-permission"
                        @click="saveAllPermissions"
                    >{{ getVerbose('permissions_save_button') }}</el-button>
                </el-tab-pane>
            </el-tabs>
        </el-card>
    </simple-layout>
</template>


<script>
import RoleAndUsers from './roles-and-users.vue';
import ModelPermission from './model-permission.vue';
import { mapGetters } from 'vuex';
export default {

    components: {
        RoleAndUsers,
        ModelPermission
    },

    props: {

    },

    data (){
        return {
            currentTab: 'manage-roles'
        };
    },

    computed: {
        ...mapGetters([
            'concretePermissions',
            'concreteRoles',
        ]),
        ...mapGetters('fundation', [
            'getVerbose',
        ]),

    },

    methods: {
        saveAllPermissions (){
            let promises = [];
            for(let perm of this.$refs.perm){
                promises.push(perm.save());
            }

            Promise.all(promises).then(() => {
                this.$notify.success(this.getVerbose('permissions_update_successfull_message'));
            }).catch((e) => {
                console.error(e);

            });
        },
    },
};
</script>

<style lang="scss">
.btn-save-permission{
    margin-top: 15px;
    display: flex;
    margin-left: auto;
}

.permission-header{
    margin: 20px;
    display: flex;
    .model-name{
        flex-basis: 15%;
    }
    .roles-titles{
        display: flex;
        flex-basis: 85%;

        strong{
            flex-basis: 25%;
        }
    }
}
</style>



// WEBPACK FOOTER //
// node_modules/fundation-app-vuejs/src/components/permissionsManagement/index.vue